import * as React from 'react';

import Plans from "./Plans";

class CreateAccount extends React.Component {
    render() {
        return (
            <div className="container cta success">
                <div className="content">
                    <p className="sub">Create your account</p>
                    <h2>Start Your Free Trial</h2>
                    <p>Try Speedweaver free for 7 days. Upload tuning files and edit them straight from your browser. No charge until your trial ends.</p>
                </div>
                <Plans {...this.props} />
            </div>
        );
    }
}

export default CreateAccount;
